<template>
  <Header />
  <router-view />
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";
import Header from "@/views/Header/Header.vue";
import { initRem } from "@/utils/rem";
import { visitorPingApi, visitorSessionApi } from "@/api/other";

// 定义接口
interface ApiResponse {
  code: number;
  data: string;
  message?: string;
}

let pingInterval: NodeJS.Timer | null = null;

// 初始化访客会话
const initVisitorSession = async () => {
  try {
    const res = (await visitorSessionApi()) as ApiResponse;
    if (res.code === 200 && res.data) {
      localStorage.setItem("sessionId", res.data);
      startPingInterval();
    }
  } catch (error) {
    console.error("Failed to init visitor session:", error);
  }
};

// 开始ping间隔
const startPingInterval = () => {
  pingInterval = setInterval(async () => {
    const sessionId = localStorage.getItem("sessionId");
    if (sessionId) {
      try {
        await visitorPingApi(sessionId);
      } catch (error) {
        console.error("Failed to ping:", error);
      }
    }
  }, 5000);
};

// 初始化访客统计
const initVisitorTracking = async () => {
  const sessionId = localStorage.getItem("sessionId");
  if (!sessionId) {
    await initVisitorSession();
  } else {
    startPingInterval();
  }
};

onMounted(() => {
  // 初始化rem
  initRem();

  // 初始化访客统计
  initVisitorTracking();

  console.log("window.location.protocol--", window.location.protocol);
  if (window.location.protocol !== "https:") {
    window.location.href = "https://lostbeasts.net/";
  }
});

// 清理定时器
onUnmounted(() => {
  if (pingInterval) {
    clearInterval(pingInterval);
    pingInterval = null;
  }
});
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  border: 0;
  box-sizing: border-box;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@font-face {
  font-family: DFP;
  src: url("./assets/font/dfp.ttf");
}

@font-face {
  font-family: FCH;
  src: url("./assets/font/FCH.TTF");
}
</style>